import { render } from "./Confirm_email_validate.vue?vue&type=template&id=5ebe4868"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__